import React, { Fragment, useCallback, useRef, useState } from 'react';
import Css from './ContentItemsMoby.module.css';
import ProductItemMoby from './ProductItemMoby/ProductItemMoby';
import SkeletonItemsMoby from './SkeletonItemsMoby/SkeletonItemsMoby';
import Shapes from './../../../../Loader/Shapes/Shapes';
import { nanoid } from 'nanoid';
import { useLazyLoading } from './useLazyLoading';
import { useEffect } from 'react';


const ContentItemsMoby = React.memo((props) => {

  let catologItems = [];
  catologItems = props.catologItems;

  const [fetchingLoader, setFetchingLoader] = useState(false);



  
  return (

    <div className={Css.content}>
      <div className={Css.listAtems} >
        {props.isFetchingItems ? Array.from(new Array(24)).map((u, i) => {
          return (
            <div key={nanoid()} className={Css.userBlock} style={{ paddingLeft: "10px", marginTop: "29px", marginBottom: "40px" }}>
              <SkeletonItemsMoby />
            </div>
          )
        })
          :
          catologItems
          
            .map((u, i) =>
              <div key={nanoid()} className={Css.userBlock}>
                <Fragment>
                  <ProductItemMoby price={u.CATALOG_PRICE_1} previewText={u.PREVIEW_TEXT} image={u.TIMTHUB} title={u.NAME} producer={u.PROPERTY_PRODUCER_VALUE} country={u.PROPERTY_COUNTRY_VALUE} idItem={u.ID} ppid={u.CATALOG_PRICE_ID_1} code={u.CODE} basketFish={props.basketitemsId.includes(u.ID, 0)} getCatalogItemsFish={props.getCatalogItemsFish} fakprice={u.PROPERTY_FAKEPRICE_VALUE} saleprice={u.CATALOG_PRICE_1_SALE} discont={u.PROPERTY_DISCOUNT_VALUE} images={u.TIMTHUB_IMAGES} />
                </Fragment>
              </div>
            )
        }
      </div>
      {fetchingLoader ?
        <Shapes />
      : <></>
      }
    </div>
  );
})

export default ContentItemsMoby;